import { createFileRoute, redirect } from '@tanstack/react-router';

/** Redirect to /bulk/all-campaigns */
export const Route = createFileRoute('/bulk_/')({
  beforeLoad: () => {
    throw redirect({
      to: '/bulk/$subNav',
      params: {
        subNav: 'all-campaigns',
      },
    });
  },
});
